// src/shared/components/MarkdownField/MarkdownHelpPopover.tsx

import { Popover, ActionIcon, Text, List, Anchor, Code, Stack } from '@mantine/core';
import { IconHelp } from '@tabler/icons-react';
import { useState } from 'react';

/**
 * Help popover showing Markdown syntax reference.
 * Mirrors the legacy MarkdownInfoTooltip content.
 */
export function MarkdownHelpPopover() {
  const [opened, setOpened] = useState(false);

  return (
    <Popover
      opened={opened}
      onChange={setOpened}
      position="bottom-end"
      width={320}
      shadow="md"
      withArrow
    >
      <Popover.Target>
        <ActionIcon
          variant="subtle"
          color="gray"
          size="sm"
          onClick={() => setOpened((o) => !o)}
          aria-label="Markdown help"
        >
          <IconHelp size={18} />
        </ActionIcon>
      </Popover.Target>

      <Popover.Dropdown>
        <Stack gap="xs">
          <Text size="sm">
            You can type <strong>plain text</strong> or{' '}
            <strong>Markdown</strong> for extra formatting:
          </Text>

          <List size="sm" spacing={4}>
            <List.Item>
              <Code>*italic*</Code> → <em>italic</em>
            </List.Item>
            <List.Item>
              <Code>**bold**</Code> → <strong>bold</strong>
            </List.Item>
            <List.Item>
              <Code>[Label](https://example.com)</Code> → clickable link
            </List.Item>
            <List.Item>
              <Code>- Item</Code> → bullet list
            </List.Item>
            <List.Item>
              <Code># Heading</Code> → large heading
            </List.Item>
          </List>

          <Text size="sm">
            Need more?{' '}
            <Anchor
              href="https://commonmark.org/help/"
              target="_blank"
              rel="noopener noreferrer"
              size="sm"
            >
              Full Markdown guide ↗
            </Anchor>
          </Text>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
}
